import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';
import { OptionRequiredOptionalNotSupportedStatuses } from 'store/reducers/reservation-provider/types';

export const ROOM_FORM_DATA_REQUEST = 'ROOM_FORM_DATA_REQUEST';
export const ROOM_FORM_DATA_SUCCESS = 'ROOM_FORM_DATA_SUCCESS';
export const ROOM_FORM_DATA_FAILURE = 'ROOM_FORM_DATA_FAILURE';
export const ROOM_FORM_DATA_CLEAR = 'ROOM_FORM_DATA_CLEAR';

export interface GetClientsSelectListParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetClientsSelectListData {
  rows: DropdownItem[];
  totalCount: number;
}

export interface GetReservationProvidersSelectListParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetReservationProvidersSelectListData {
  rows: DropdownItem[];
  totalCount: number;
}

export interface LodgingOptionDetails {
  name: string;
  lodgingType: string;
  address: string;
}

export interface RoomFormData {
  roomTypes: DropdownItem[];
  occupancy?: number;
  totalRate?: number;
  typeId?: string;
  reservationId?: string;
  fromDate?: string;
  toDate?: string;
  corporateClientName: string;
  reservationProviderId?: string;
  reservationProviderName?: string;
  providerSendNotification?: boolean;
  clcRequestNumber?: string;
  lodgingOptionDetails?: LodgingOptionDetails;
  lodgingPolicy: string;
  lodgingOptionId?: string;
  doNotSendToAssociate?: boolean;
  doNotSendToCLC?: boolean;
  requestNumberRequired?: OptionRequiredOptionalNotSupportedStatuses;
};

export type RoomFormDataState = DefaultState & {
  contents?: RoomFormData;
};

interface RoomFormDataRequest {
  type: typeof ROOM_FORM_DATA_REQUEST;
};

interface RoomFormDataSuccess {
  type: typeof ROOM_FORM_DATA_SUCCESS,
  contents: RoomFormData;
}

interface RoomFormDataClear {
  type: typeof ROOM_FORM_DATA_CLEAR,
  contents: undefined;
}

interface RoomFormDataFailure {
  type: typeof ROOM_FORM_DATA_FAILURE;
}

export type RoomFormDataActionTypes = RoomFormDataRequest | RoomFormDataSuccess | RoomFormDataFailure | RoomFormDataClear;